import { takeLatest, call, put } from 'redux-saga/effects';

import axiosInstance from '../../services/AuthHeader';
import { setResetPasswordWithTokenResult } from '../reducers/authorization';
import { setSending, unsetSending } from '../reducers/serverCommunication';

export const SAGA_SEND_NEW_PASSWORD_WITH_RESET_TOKEN = 'SAGA_SEND_NEW_PASSWORD_WITH_RESET_TOKEN';

export function sendNewPasswordWithResetTokenSaga(id, newPassword, token) {
  const payload = { id, newPassword, token };
  return { type: SAGA_SEND_NEW_PASSWORD_WITH_RESET_TOKEN, payload };
}

const handleResetPasswordWithToken = async ({ id, newPassword, token }) => {
  const params = new URLSearchParams();
  params.append('userId', parseInt(id));
  params.append('newPassword', newPassword);
  params.append('token', token);

  return axiosInstance
    .post('/api/reset/changePassword', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    .then((res) => res.data);
};

export function* sendResetPasswordWithToken(action) {
  yield put(setSending);
  try {
    yield call(handleResetPasswordWithToken, action.payload);
    yield put(setResetPasswordWithTokenResult(true));
  } catch (e) {
    // default to 500 if no "status code" is found, but error occurred.
    yield put(
      setResetPasswordWithTokenResult(false, e?.response?.data, e?.response?.status || 500),
    );
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForSendNewPasswordWithResetToken() {
  yield takeLatest(SAGA_SEND_NEW_PASSWORD_WITH_RESET_TOKEN, sendResetPasswordWithToken);
}
